<template>
  <div class="min-h-screen p-8 stores bg-white">
    <p class="text-center font-bold text-green-500 text-3xl">N {{numberFormat(totalRevenue, '0,0')}}</p>
    <p class="text-center text-gray-500 text-xl font-light" >Total Revenue</p>
    <div class="nations mt-12">
      <p>All Nations</p>
      <el-radio-group class="flex flex-col justify-start" v-model="checkedNations" >
        <el-radio @change="fetchData('nation')" class="mt-2" v-for="nation in nationList" :label="`${nation.address}`">{{nation.address}}</el-radio>
      </el-radio-group>
    </div>
    <div class="mt-12" v-if="stateList.length > 0">
      <p>States in {{checkedNations}}</p>
      <el-radio-group class="flex flex-col justify-start" v-model="checkedStates" >
        <el-radio @change="fetchData('state')" class="mt-2" v-for="state in stateList" :label="`${state.address}`">{{state.address}}</el-radio>
      </el-radio-group>
    </div>
    <div class="outlets mt-12" v-if="outletList.length > 0">
      <p>Outlets in {{checkedStates}}, {{checkedNations}}</p>
      <el-radio-group class="flex flex-col justify-start" v-model="checkedOutlets" >
        <el-radio @change="fetchData" class="mt-2" v-for="outlet in outletList" :label="`${outlet.address}`">{{outlet.address}}</el-radio>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoresDetails',
  data() {
    return {
      value: 'nations',
      checkedNations: '',
      checkedStates: '',
      checkedOutlets: '',
      stateList: [],
      outletList: [],
      options: [{
        value: 'nations',
        label: 'Nations',
      }, {
        value: 'states',
        label: 'States',
      }, {
        value: 'outlets',
        label: 'Outlets',
      }],
    };
  },
  computed: {
    totalRevenue() {
      return this.$store.state.AIGeospatial.stores.total_revenue;
    },
    nationList() {
      return this.$store.state.AIGeospatial.stores.nations;
    },
  },
  methods: {
    setFilter() {
      this.$store.commit('AIGeospatial/setProperty', { property: 'filter', payload: this.value });
    },
    async fetchData(type) {
      switch (type) {
        case 'nation':
          this.stateList = [];
          this.outletList = [];
          // Display States;
          this.stateList = this.$store.getters['AIGeospatial/getStatesForTheSelectedNation'](this.checkedNations);

          await this.$store.commit('AIGeospatial/setProperty', { property: 'chart_filters', payload: { country: this.checkedNations } });
          await this.$store.commit('AIGeospatial/setProperty', { property: 'filter', payload: 'states' });
          await this.$store.commit('AIGeospatial/setChartRegion', this.checkedNations);
          await this.$store.dispatch('AIGeospatial/fetchProducts');
          await this.$store.dispatch('AIGeospatial/fetchSales');

          break;
        case 'state':
          this.outletList = [];
          // Then Display Outlet
          this.outletList = this.$store.getters['AIGeospatial/getOutletsForTheSelectedStates'](this.checkedStates);

          // Fetch Data for this state

          await this.$store.commit('AIGeospatial/setProperty', { property: 'chart_filters', payload: { state: this.checkedStates } });
          await this.$store.commit('AIGeospatial/setProperty', { property: 'filter', payload: 'outlets' });
          await this.$store.commit('AIGeospatial/setChartRegion', this.checkedNations);
          await this.$store.dispatch('AIGeospatial/fetchProducts');
          await this.$store.dispatch('AIGeospatial/fetchSales');

          break;
        default:
          // fetch data for this outlet
          await this.$store.commit('AIGeospatial/setProperty', { property: 'chart_filters', payload: { state: this.checkedOutlets } });
          await this.$store.dispatch('AIGeospatial/fetchProducts');
          await this.$store.dispatch('AIGeospatial/fetchSales');
          break;
      }
    },
  },
  mounted() {
    if (this.nationList && this.nationList.length > 0) {
      this.checkedNations = this.nationList[0].address;
    }

    if (this.stateList && this.stateList.length > 0) {
      this.checkedStates = this.stateList[0].name;
    }

    if (this.outletList && this.outletList.length > 0) {
      this.checkedOutlets = this.outletList[0].name;
    }
  },
};
</script>

<style scoped>
  .stores {
    flex: 0 1 23%;
  }

  .outlets {
    height: 300px;
    overflow: scroll;
  }
</style>
